import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  createMigrate,
  FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import themeReducer from './slices/themeSlice';
import langReducer from './slices/langSlice';
import userReducer from '../auth/store/userSlice';
import ssoUserReducer from '../auth/store/ssoUserSlice';

const rootReducer = combineReducers({
  theme:   themeReducer,
  lang:    langReducer,
  user:    userReducer,
  ssoUser: ssoUserReducer,
});

// Migration: force dark default when persisted state schema changes.
const migrations = {
  2: (state: any) => ({
    ...state,
    theme: { variant: 'dark' },
  }),
  3: (state: any) => ({
    ...state,
    theme: { variant: 'dark' },
  }),
};

const persistConfig = {
  key: 'mopsc-root',
  version: 3,
  storage,
  whitelist: ['theme', 'lang', 'user', 'ssoUser'],
  migrate: createMigrate(migrations, { debug: false }),
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
